import { render } from "./ProfileView.vue?vue&type=template&id=466fe7bc&scoped=true&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=466fe7bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466fe7bc"]])

export default __exports__